module.exports = __webpack_public_path__ + "static/media/asnews.f71da8ad.png";